import { Page } from './Page';
import { DogsOwnersView } from '../components/dogs/DogsOwnersView';

// Dogs & Owners section. Chrome comes from <Page>; owner CREATE now lives in the
// global top-bar New menu, so the view owns only the edit-owner modal + the list.
export function DogsOwnersPage() {
  return (
    <Page title="Dogs & Owners">
      <DogsOwnersView />
    </Page>
  );
}
